// @flow
import React, { Component, Fragment } from 'react';
import { Redirect }  from "react-router-dom";
import { SignInForm } from 'forms';

type Props = {
    consumers: any
}

type State = {}

/**
 * SignIn
 * @author Tomasz tpr@deltacode.fr
 * @memberof Containers
 * @extends {React.Component}
 * @description SignIn container
 */

class SignIn extends Component<Props, State> {

    render() {
        /**
         * @instance
         * @method render
         * @memberof Containers.SignIn
         * @return { String } JSX 
        */
        const { authenticated } = this.props.consumers.connection
        const { consumers } = this.props
        return (
            <Fragment>
                {authenticated ? (
                    <Redirect to="/"/>
                ) : (
                    <SignInForm consumers={consumers}/>
                )}
            </Fragment>
        );
    }
}

export { SignIn }